import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { JobQualificationDifferences } from 'src/app/clinical/review-queue/models/job-qualification-changes.model';
import { LookupDto } from 'src/app/clinical/unit-description-configuration/models/ud-configuration-details.model';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { combine } from 'src/app/shared/utilities/route';
import { JobAndUnitRequirementsDto } from 'src/app/shared/models/job-unit-requirements.model';
import { AvailableSkillsDto } from 'src/app/shared/components/job-qualifications/models/available-skills.model';
import { CertificationWithRelated } from 'src/app/shared/components/job-qualifications/models/certification-with-related.model';
import { JobQualificationChanges } from 'src/app/shared/components/job-qualifications/models/job-qualifications-changes.model';

@Injectable({
    providedIn: 'root'
})
export class JobQualificationsService {
    private readonly _coreApiPath: string;

    constructor(
        @Inject(APP_CONFIG) _settings: Settings,
        private readonly _httpClient: HttpClient
    ) {
        this._coreApiPath = combine(_settings.coreAPIUrl, 'ayanova');
    }

    getRequirements(jobId: number): Observable<JobAndUnitRequirementsDto> {
        const url = `${this._coreApiPath}/job-qualifications/${jobId}`;
        return this._httpClient.get<JobAndUnitRequirementsDto>(url);
    }

    getChanges(jobId: number): Observable<JobQualificationChanges> {
        const url = `${this._coreApiPath}/job-qualifications/changes/${jobId}`;
        return this._httpClient.get<JobQualificationChanges>(url);
    }

    getAvailableCerts(professionId: number, expertiseId: number, clinicalTrackId: number): Observable<LookupDto[]> {
        const url = `${this._coreApiPath}/job-qualifications/available-certs/${professionId}/${expertiseId}?clinicalTrackId=${clinicalTrackId ?? 0}`;
        return this._httpClient.get<LookupDto[]>(url);
    }

    getAvailableSkills(
        professionId: number,
        expertiseId: number,
        clinicalTrackId: number
    ): Observable<AvailableSkillsDto[]> {
        const url = `${this._coreApiPath}/job-qualifications/available-skills/${professionId}/${expertiseId}?clinicalTrackId=${clinicalTrackId ?? 0}`;
        return this._httpClient.get<AvailableSkillsDto[]>(url);
    }

    getRequirementsFromUD(jobId: number): Observable<JobAndUnitRequirementsDto> {
        const url = `${this._coreApiPath}/job-qualifications/reset-ud-view/${jobId}`;
        return this._httpClient.get<JobAndUnitRequirementsDto>(url);
    }

    getJobQualificationDifferences(jobId: number): Observable<JobQualificationDifferences> {
        const url = `${this._coreApiPath}/job-qualifications/differences/${jobId}`;
        return this._httpClient.get<JobQualificationDifferences>(url);
    }

    getAllCertificationsWithRelated(): Observable<CertificationWithRelated[]> {
        const url = `${this._coreApiPath}/clinical/certification-management/all-with-related`;
        return this._httpClient.get<CertificationWithRelated[]>(url);
    }
}
